import createReducer from "utils/createReducer";
import { fromJS } from "immutable";
import { BetHistoryTypes } from "actions/types";

export const defaultValue = fromJS([]);
export const historyLinks = createReducer(defaultValue, {
  [BetHistoryTypes.SET_HISTORY_LINKS](state, { payload }) {
    let newState = fromJS(payload);
    return newState;
  },
});
